import { render, staticRenderFns } from "./TestPlayer.vue?vue&type=template&id=7ca5ba24&scoped=true"
import script from "./TestPlayer.vue?vue&type=script&lang=ts"
export * from "./TestPlayer.vue?vue&type=script&lang=ts"
import style0 from "./TestPlayer.vue?vue&type=style&index=0&id=7ca5ba24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca5ba24",
  null
  
)

export default component.exports